<template>
<v-snackbar
  v-model="enabled"
  shaped
  :color="color"
>{{ message }}</v-snackbar>
</template>

<script>
export default {
  name: "Snackbar",
  data() {
    return {
      enabled: false,
      message: '',
      color: '',
    }
  },
  methods: {
    show(message, color="") {
      this.message = message
      this.color = color
      this.enabled = true
    },
  }
}
</script>
